import { render } from "./Forgotpassword.vue?vue&type=template&id=19ba443c&scoped=true"
import script from "./Forgotpassword.vue?vue&type=script&lang=js"
export * from "./Forgotpassword.vue?vue&type=script&lang=js"

import "./Forgotpassword.vue?vue&type=style&index=0&id=19ba443c&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ba443c"]])

export default __exports__